module.exports = __webpack_public_path__ + "static/img/gspl.b6d79c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/gspl.jpg
// module id = 5Ii9
// module chunks = 0